var _circle, _circle2, _circle3, _circle4, _circle5, _circle6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatarCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 371,
    height: 371,
    viewBox: "0 0 371 371",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 185.897,
    cy: 185.897,
    r: 161.397,
    stroke: "#0054A2",
    strokeDasharray: "52 4 6 37"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 185.5,
    cy: 185.5,
    r: 185,
    stroke: "#00C2FF",
    strokeDasharray: "146 104 52 1"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 332.773,
    cy: 75.8636,
    r: 2.86364,
    fill: "#00C2FF"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 68.9092,
    cy: 41.0909,
    r: 6.54545,
    fill: "#00C2FF"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 33.3181,
    cy: 299.228,
    r: 8.59091,
    fill: "#00C2FF"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 185.608,
    cy: 185.608,
    r: 144.608,
    fill: "#0094FF",
    fillOpacity: 0.14
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarCircle);
export default __webpack_public_path__ + "static/media/avatarCircle.5457ad21ac2805c6bd6d76eb47ba113c.svg";
export { ForwardRef as ReactComponent };